import Http from '../http'

// 实时监控模块API
export default {
  // 我的地图列表
  getMyMapList (params) {
    // 1点 2矩形  3多边形  9线  10圆
    return Http.post('/marker/list.do', params)
  },
  // 报警处理
  alarmHandle (params) {
    return Http.post('/web/alarmHandle.do', params)
  },
  // 报警屏蔽列表
  alarmShieldList(params) {
    return Http.post('alarmShield/list.do', params)
  },
  // 新增报警屏蔽
  addAlarmShield(params) {
    return Http.post('alarmShield/add.do', params)
  },
  // 修改报警屏蔽
  updateAlarmShield(params) {
    return Http.post('alarmShield/update.do', params)
  },
  // 获取报警屏蔽
  getAlarmShield(params) {
    return Http.post('alarmShield/get.do', params)
  },
  // 删除报警屏蔽
  deleteAlarmShield(params) {
    return Http.post('alarmShield/delete.do', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/realTimeMonitor.js